// extracted by mini-css-extract-plugin
module.exports = {"default":"idt-sizeattributeradio_default__1atfu","active":"idt-sizeattributeradio_active__3hih4","preview":"idt-sizeattributeradio_preview__2yde4"};